import fetchAllContracts from './fetchAllContracts';
import fetchContract from './fetchContract';
import addContract from './addContract';
import updateContract from './updateContract';
import deleteContract from './deleteContract';

export default {
  fetchAllContracts,
  fetchContract,
  addContract,
  updateContract,
  deleteContract,
};
